import React from 'react';
import { CustomCard, CardBody } from "../../../../components/CustomCard";
import ReadMore from "../../../../components/ReadMore";
import ListComponent from '../MeetingList/MeetingList';

interface PreviousMeetingCardProps {
    meetingData: any[];
}

const PreviousMeetingCard = ({
    meetingData = [],
}: PreviousMeetingCardProps) => {

    return (
        <CustomCard>
            <CardBody className="p-4 flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    {
                        meetingData.length > 2 ? (
                          <ReadMore linkAbove={false} initialHeight="82px" bgColor="indigo-900">
                              <ListComponent
                                meetingData={meetingData}
                                isPreviousMeetings={true}
                                animate={false}
                                onCancellation={() => console.log('not used')}
                              />
                          </ReadMore>
                        ) : (
                          <ListComponent
                            meetingData={meetingData}
                            isPreviousMeetings={true}
                            animate={false}
                            onCancellation={() => console.log('not used')}
                          />
                        )
                    }

                </div>
            </CardBody>
        </CustomCard>
    );
};

export default PreviousMeetingCard;
